import { RawAnchorTagData } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { CmsModuleData } from '@activebrands/core-web/types/modules';
import Accordion from 'components/content-components/Accordion';

export interface RawAccordionItemData {
    _uid?: string;
    accordionContent?: CmsModuleData[];
    anchorTag?: RawAnchorTagData[];
    component?: string;
    label?: string;
}

export interface AccordionContent {
    _editable?: string;
    accordionItems?: RawAccordionItemData[];
    anchorTag?: RawAnchorTagData[];
}

export interface AccordionDataTransformerBlockProps {
    content?: AccordionContent;
}

const AccordionDataTransformerBlock = ({ content = {} }: AccordionDataTransformerBlockProps) => {
    const { _editable, anchorTag = [], accordionItems = [] } = content;

    const transformedItems = accordionItems.map(item => {
        const { _uid, label, accordionContent, component, anchorTag } = item;
        return {
            anchorTag: transformAnchorTag({ anchorTag }),
            _uid,
            name: label,
            blocks: accordionContent,
            component,
        };
    });

    return (
        <Accordion
            id={transformAnchorTag({ anchorTag })}
            items={transformedItems}
            sbEditable={transformPreviewEditable(_editable)}
        />
    );
};

export default AccordionDataTransformerBlock;
